/* eslint-disable max-lines */
/**
 *@author Wj
 *@date 2024/7/24
 *@Description:渠道统一管理
 */

import type { getAdChannelCodeByRouteCodeRes } from '@/apis'
import { activityApiDecorator, ChannelDetailResponse } from '@/apis/activity'
import { ROUTE_CODE_DIRECT_DRAINAGE_CONTEXT } from '@/constants/storage'
import { isProduct } from '@/utils/common-js'
import { cachePromiseNoClear, retry } from '@/utils/utils'
import { create } from 'zustand'

export interface adChannelState {
  adChannelCode: string
  isSpecialChannel: boolean
  specialCode: Record<string, { value: string; code: string[] }>
  channelValue: string[]
  codeDetailCache: ChannelDetailResponse | null
  noStandardChannel:boolean
  adRouteCode: string
  routeCodeDetail: getAdChannelCodeByRouteCodeRes | null
}

export const selectIsFormProcess5Channel = (
  state: Pick<adChannelState, 'channelValue' | 'noStandardChannel'>
) => state.noStandardChannel || Boolean(state.channelValue?.includes('formprocess5'))

export interface RouteCodeDirectDrainageContext {
  adRouteCode: string
  routeCodeDetail: getAdChannelCodeByRouteCodeRes
}

/**
   * 特殊渠道定制 - 年代比较久，没有产品文档
   * @value bdVid 百度渠道访问时会有一个bd_vid，如果是百度渠道来的，到了授权页时需要通过授权接口将它传给后端，页面没有特定展示内容
   * @intruduce 百度渠道访问时会有一个bd_vid，如果是百度渠道来的，到了授权页时需要通过授权接口将它传给后端，页面没有特定展示内容
   * @append 追加需求：百度渠道单独定制落地页。
   * @append noListMainBody -- 列表不展示公司主体
   * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=2511-1946&t=iEcT0VtX63JlIXt4-0
   * @link 产品文档:-
   */

/**
    * 特殊渠道定制
    * @value kuaishou
    * @Infomation 快手渠道v0.1.26 - 特殊渠道定制
    * @intruduce CG5Gd7是测试渠道,其余是正式渠道
    * @intruduce 更改主体和备案号
    * @intruduce 登录注册页的协议更换公司主体，匹配授权页协议更换公司主体,公司主体为：’广州市聚富互联网小额贷款有限公司‘
    * @intruduce 匹配到一个或多个产品均不展示公司主体名
    * @append 追加需求：将快手渠道加入到聚客融皮肤中。
    * @link 产品文档:https://chongdong.feishu.cn/docx/InObd3Ue5oR3OSxdjxPcrKYbncg
    */

/**
   * 特殊渠道定制
   * @value formprocess3 表单流程3
   * @intruduce 快手渠道表单流程定制，整体项目流程重新定制
   * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=5159-38824&node-type=frame&t=E7JkfAppc4Y1gvvF-0
   * @link 产品文档:-
   */

/**
   * 特殊皮肤定制
   * @value fenqile
   * @Infomation 分期乐 -未开始版本号 - 特殊皮肤定制
   * @intruduce 整体UI重构，内容较多,详细内容查看文档
   * @link 产品文档:https://chongdong.feishu.cn/wiki/U6lBwdyKHi6ZSIkACH0cHnM9nVb
   */

/**
   * 特殊皮肤定制
   * @value baidu
   * @Infomation 百度 -未开始版本号 - 特殊皮肤定制
   * @intruduce 整体UI重构，内容较多,详细内容查看文档
   * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=2511-1946&t=iEcT0VtX63JlIXt4-0
   * @link 产品文档:-
 */

/**
   * 特殊皮肤定制
   * @value registerTips
   * @intruduce 底部添加贷款有风险 借款需谨慎文案
   */

/**
   * 特殊皮肤定制
   * @value hbRegisterCustomized
   * @intruduce 还呗注册页面定制，标签和按钮内容定制
   */

/**
   * 特殊皮肤定制
   * @value jiezhanggui
   * @intruduce 有钱花注册页面定制，服务协议、隐私政策、信息共享授权协议内容定制
   */

/**
   * 特殊主体定制
   * @value zhonganXy
   * @intruduce 修改全局的主体为深圳市中安信业小额贷款有限公司
   */

/**
   * 特殊功能定制
   * @value backRegister -- 点击返回清空缓存回到注册页
   */

/**
   * 特殊功能定制
   * @value noListMainBody -- 列表不展示公司主体
   */

/**
   * 特殊功能定制
   * @value ksBurying -- 快手埋点
   */

/**
   * 特殊功能定制
   * @value justShowProduct -- 只展示产品名称
   */

/**
   * 特殊功能定制
   * @value iosInstallyqqb -- ios下载有钱钱包apk包
   */

/**
   * 特殊功能定制
   * @value jkrHaierDownloadApp -- 聚客融海尔下载自己的app
   */

/**
   * 特殊功能定制
   * @value justShowProduct -- 授权页面只展示产品名称
   */

/**
   * 特殊落地页定制
   * @value skin系列 -- skin后面跟指定皮肤，指展示落地页皮肤
   */

/**
   * 特殊落地页定制
   * @value noCompanyName -- 落地页不展示公司主体名称
   */

/**
   * 去掉授权页加载时间
   * @value removeLoadingTime -- 去掉授权页加载时间
   */

/**
   * 特殊功能定制
   * @value soulBurying -- soul埋点
   */

/**
   * 跳转微信
   * @value jumpWeixin -- h5调起微信小程序
   */

/**
   * 跳转微信
   * @value showKuaishouRegisterText -- 快手落地页修改底部文案
   */

/**
   * 跳转微信
   * @value shallowBlue -- 分期乐的#29A8FF色号皮肤
   */

/**
   * 跳转微信
   * @value highInterest -- 皮肤17高利息展示
   */

/**
   * 跳转微信
   * @value middleInterest -- 皮肤17中等利息展示
   */

/**
   * 跳转微信
   * @value norlmalInterest -- 皮肤17普通利息展示
   */

/**
   * 分期乐定制
   * @value fenqilePhoneModel -- 分期乐的非oppo和vivo机型访问结果页，可以展示后端h5变现
   */

/**
   * 分期乐定制
   * @value juhuihuaForm -- 聚惠花表单流程定制，表单页不填写身份证号和姓名
   */

/**
   * 分期乐定制
   * @value daidaijia --  全局名称改为贷贷嘉
   */

/**
   * 湘江源定制
   * @value xiangJiangYuan -- 全局使用公司主体：湘江源
   */

/**
  * 湘江源定制
  * @value jiSuJieKuan -- 使用title为极速借款
  */

/**
  * 贷贷嘉-红色定制
  * @value daidaijiaRed -- 改全局主体为贷贷嘉，全局颜色改为红色
  */


let specialChannelCode = {

  /**
   * 树成渠道人工录单独立流程
   */
  manualCustomerEntryCode: {
    value: 'manualCustomerEntry',
    code: ['Al0XaP', 'X0iJba', 'ocGXRC', 'yjG0lH', 'oryeIR']
  },

  /**
    * 特殊渠道定制
    * @value jiezhanggui
    * @channel 7SWRtn是测试渠道
    * @Infomation 借掌柜-有钱钱包 - 特殊渠道定制
    * @intruduce 修改注册页和授权页协议主体的名称为本平台
    */
  jiezhangguiCode: {
    value: 'jiezhanggui-shallowBlue',
    code: ['QndVP8', '7SWRtn']
  },

  /**
    * 特殊渠道定制
    * @value jiezhanggui
    * @channel 7SWRtn是测试渠道
    * @Infomation 借掌柜-有钱钱包 - 特殊渠道定制
    * @intruduce 修改注册页和授权页协议主体的名称为本平台
    */
  jiezhanggui3Code: {
    value: 'jiezhanggui-shallowBlue',
    code: ['P9mMYf', '3rtbJk']
  },

  /**
      * 特殊渠道定制
      * @Infomation 还呗渠道v0.1.19 - 特殊渠道定制
      * @intruduce SNTxDz是测试渠道码 其余是正式渠道
      * @intruduce 更改主体和备案号
      * @intruduce 在做这个需求时将全局的有钱来更换为有钱钱包
      * @intruduce 匹配到一个或多个产品均不展示公司主体名
      * @intruduce 将全局的主体更换为深圳市中安信业小额贷款有限公司 zhonganXy
      * @link 产品文档:https://chongdong.feishu.cn/docx/HM3ydfbj2ozaZ2x4CNsc60bdnUh
      */
  huanbeiCode: {
    value: 'huanbei-zhonganXy-hbRegisterCustomized-skin8',
    code: ['7wQBe8', 'AHb0TS', 'QYnEeB', '1Lnjly', '9N9JE8', '8nXIby', 'FLmCZN']
  },

  /**
   * 特殊渠道定制
   * @Infomation 还呗小程序渠道
   * @intruduce FnbhpG是正式渠道
   * @intruduce 更改主体和备案号
   * @intruduce 在做这个需求时将全局的有钱来更换为有钱钱包
   * @intruduce 匹配到一个或多个产品均不展示公司主体名·
   * @intruduce 将全局的主体更换为深圳市中安信业小额贷款有限公司 zhonganXy
   * @link 产品文档:https://chongdong.feishu.cn/docx/HM3ydfbj2ozaZ2x4CNsc60bdnUh
  */
  huanbeiProgramCode: {
    value: 'huanbei-zhonganXy-hbRegisterCustomized',
    code: ['FnbhpG']
  },

  /**
    * 特殊渠道定制
    * @Infomation 还呗 - 特殊渠道定制
    * @intruduce O1d538,其余是正式渠道
    * @intruduce 更改主题色
    * @link 产品文档:https://chongdong.feishu.cn/docx/HM3ydfbj2ozaZ2x4CNsc60bdnUh
  */
  huanbeiThemeCode: {
    value: 'huanbeitheme-huanbei-zhonganXy-hbRegisterCustomized-huanbeiRegiste-showCardLogo-highInterest-removeNotice-btnTextRegisterNow-removeCornerMark',
    code: ['XPPL9v', 'hKvhDm']
  },

  /**
    * 特殊渠道定制
    * @Infomation 还呗 - 特殊渠道定制
    * @intruduce O1d538,其余是正式渠道
    * @intruduce 更改主题色
    * @link 产品文档:https://chongdong.feishu.cn/docx/HM3ydfbj2ozaZ2x4CNsc60bdnUh
  */
  huanbeiInterestCode: {
    value: 'huanbeitheme-huanbei-zhonganXy-hbRegisterCustomized-huanbeiRegiste-showCardLogo-huanbeiInterest-removeNotice-btnTextRegisterNow-removeCornerMark',
    code: ['O1d538','V0ax71']
  },

  /**
    * 特殊渠道定制
    * @Infomation 还呗 - 特殊渠道定制
    * @intruduce O1d538,其余是正式渠道
    * @intruduce 更改主题色
    * @link 产品文档:https://chongdong.feishu.cn/docx/HM3ydfbj2ozaZ2x4CNsc60bdnUh
  */
  huanbeiChannelCode: {
    value: 'removeNotice-removeCornerMark',
    code: ['9tFjdK', 'ksaYls']
  },

  /**
    * 特殊渠道定制
    * @Infomation 分期乐 -未开始版本号 - 特殊渠道定制
    * @intruduce Sy3uTn,其余是正式渠道
    * @intruduce 用分期乐定制的皮肤 -fenqile
    * @intruduce 分期乐的非oppo和vivo机型访问结果页，可以展示后端h5变现 -fenqilePhoneModel
  */
  fenqileCode: {
    value: 'fenqile-shallowBlue-fenqilePhoneModel',
    code: ['9o0w2B']
  },

  /**
    * 分期乐icon渠道 特殊渠道定制--ABtest翻页表单
    * @Infomation 分期乐 -未开始版本号 - 特殊渠道定制
    * @intruduce GOm2Rn,其余是正式渠道
    * @intruduce 分期乐的非oppo和vivo机型访问结果页，可以展示后端h5变现 -fenqilePhoneModel
   */
  fenqile2ABTestCode: {
    value: 'fenqilePhoneModel-userBlocker-shallowBlue',
    code: ['OaruWX', 'GOm2Rn']
  },

  /**
    * 分期乐icon渠道 特殊渠道定制-ABtest默认表单
    * @Infomation 分期乐 -未开始版本号 - 特殊渠道定制
    * @intruduce hQ1Hgk,其余是正式渠道
    * @intruduce 分期乐的非oppo和vivo机型访问结果页，可以展示后端h5变现 -fenqilePhoneModel
   */
  fenqile2ABTestCodeDefault: {
    value: 'fenqilePhoneModel-userBlocker-shallowBlue-jiSuJieKuan-guideModal-productApplication',
    code: ['hQ1Hgk', 'DUF8CJ']
  },

  /**
    * 特殊渠道定制
    * @Infomation 聚惠花 - 特殊渠道定制
    * @intruduce Sy3uTn,其余是正式渠道
    * @intruduce 用分期乐定制的皮肤 -fenqile
    * @intruduce 皮肤17 -skin17
  */
  juhuihuaCode: {
    value: 'fenqile-juhuihuaForm',
    code: ['00b1go', 'dejyvy']
  },

  /**
    * 特殊渠道定制 - 年代比较久，没有产品文档
    * @intruduce 百度渠道访问时会有一个bd_vid，如果是百度渠道来的，到了授权页时需要通过授权接口将它传给后端，页面没有特定展示内容 -- bdVid
   */
  baiduCode: {
    value: 'bdVid-noListMainBody-skin13',
    code: [ '5oNfJw']
  },

  /**
      * 特殊渠道定制
      * @Infomation 海尔消金 - 特殊渠道定制
      * @intruduce 渠道需要返回按键直接返回到登录页，并清除掉状态 --backRegister
      * @link 落地页figma文档:-
      * @link 产品文档:-
   */
  haierCode: {
    value: 'backRegister-iosInstallyqqb',
    code: ['r97gwM', 'dhT0rS', 'WczP9d']
  },

  /**
      * 特殊渠道定制
      * @Infomation 拍拍贷 - 特殊渠道定制
      * @intruduce 拍拍贷结果页需要判断ios和小米系统，如果为ios则直接跳转到appstore，小米手机跳转小米应用市场
      * @intruduce 5XR0vc是测试渠道，其余是正式渠道
      * @link 落地页figma文档:-
      * @link 产品文档:
   */
  paipaidaiCode: {
    value: 'paipaidai-iosInstallyqqb',
    code: ['t4xtSe', '5XR0vc']
  },

  // 特殊处理下载方式
  paipaidaiCode2: {
    value: 'paipaidai',
    code: ['pmeLeA', 'rWMspl', 'ZgvvGJ']
  },

  /**
      * 特殊渠道定制
      * @Infomation 哈罗 - 特殊渠道定制
      * @intruduce eIKC1Q
      * @link 落地页figma文档:- https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=5063-274&node-type=canvas&t=3Ckea9ublruN1won-0
      * @link 产品文档:
   */
  haluoCode: {
    value: 'zhonganXy-btnTextRegisterNow-removeNotice-haluoRegisterTitle',
    code: ['3HVc78', 'vHpl6q', 'K1pdGR', 'TSi8R9', 'U2HZEY','eIKC1Q']
  },

  /**
    * 特殊渠道定制
    * @Infomation  -特殊渠道定制
    * @intruduce MvALAB是测试渠道，其余是正式渠道
    * @intruduce  表单流程3 --formprocess3
    * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=5159-38824&node-type=frame&t=E7JkfAppc4Y1gvvF-0
    * @link 产品文档:
  */
  yqqbFormProcess: {
    value: 'formprocess3-yqqbKuaishou-ksBurying-skin16',
    code: ['Wzv7Xu']
  },

  /**
    * 特殊渠道定制
    * @Infomation  -特殊渠道定制
    * @intruduce MvALAB是测试渠道，其余是正式渠道
    * @intruduce  表单流程3 --formprocess3
    * @intruduce  有钱钱包快手渠道 --yqqbKuaishou
    * @intruduce  快手埋点 --ksBurying
    * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=5159-38824&node-type=frame&t=E7JkfAppc4Y1gvvF-0
    * @link 产品文档:
  */
  yqqbForm2Process: {
    value: 'formprocess3-yqqbKuaishou-ksBurying',
    code: ['MvALAB', '0DVRCz', 'Ni0cC8', 'fUZ7VE']
  },

  /**
    * 特殊渠道定制
    * @Infomation  -魅塔特殊渠道定制
    * @intruducet FEU1eT是测试渠道，其余是正式渠道
    * @intruduce  表单流程3 --formprocess3
    * @link 落地页figma文档:https://www.figma.com/design/Sb8JYsEFmDAuIClPIksaVa/%E6%9C%89%E9%92%B1%E6%9D%A5---%E9%87%8D%E6%9E%84?node-id=8700-98325&node-type=canvas&t=dgG4aaLVyFENAvJH-0
    * @link 产品文档:
  */
  metaCode: {
    value: 'formprocess3-meta-skin16',
    code: ['eB6SEI', 'fYfU7m', 'FEU1eT', 'sHzsQc', 'EMr7AJ']
  },

  /**
    * 特殊渠道定制
    * @Infomation 闪电借款 - 特殊渠道定制
    * @intruduce QfgoG0是测试渠道，其余是正式渠道
    * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=5484-7777&t=L2u8kRlls0yH56LX-1
    * @link 产品文档:
  */
  kuaishouCode: {
    value: 'formprocess3-yqqbKuaishou-ksBurying-middleInterest',
    code: ['e65s8P', '09rsUa', 'xMdLiZ', '0ZDgkl', 'LBAXc6', '9DBnBq', 'g4st2I', 'YtEcqZ', 'SNTxDz']
  },

  /**
    * 特殊渠道定制
    * @Infomation 闪电借款 - 特殊渠道定制
    * @intruduce QfgoG0是测试渠道，其余是正式渠道
    * @link 落地页figma文档:https://www.figma.com/design/QL5Bzxwqwscr1iDhvgO5r2/%E6%9C%89%E9%92%B1%E6%9D%A5-v0.1?node-id=5484-7777&t=L2u8kRlls0yH56LX-1
    * @link 产品文档:
  */
  kuaishouFormProcess4Code: {
    value: 'formprocess4-yqqbKuaishou-ksBurying',
    code: ['ub7v5s', 'berD1P', 'UuyvDc','t5dPdI']
  },

  /**
    * 特殊渠道定制
    * @Infomation 贷贷嘉 - 特殊渠道定制
    * @intruduce 主题色改为深蓝色 --  deepBlue
    * @intruduce 全局名称改为贷贷嘉 --  daidaijia
    * @intruduce 将全局的主体更换为深圳市中安信业小额贷款有限公司 --  zhonganXy
    * @link 落地页figma文档:https://www.figma.com/design/32uowLM7szdeKDzCgKn0Ds/%E6%9C%89%E9%92%B1%E6%9D%A5-v2.0?node-id=4255-64611&p=f&t=kKdbZcpQGge7xY8m-0
    * @link 产品文档:
  */
  DaiDaiJiaCode: {
    value: 'daidaijia-zhonganXy-skin20-halo',
    code: ['uLZycd', 'MFkOeE']
  },

  /**
    * 特殊渠道定制
    * @Infomation 湘江源 - 特殊渠道定制
    * @intruduce uNIXTy是测试渠道，其余是正式渠道
    * @link 产品文档:https://chongdong.feishu.cn/docx/QScYdRcnsottq1xvdoHcOs82n7e
  */
  XiangJiangYuanCode: {
    value: 'skin19-xiangJiangYuan',
    code: [ 'LvktO8','uNIXTy']
  },

  /**
    * 特殊渠道定制
    * @Infomation 元闪融 - 特殊渠道定制
    * @intruduce uNIXTy是测试渠道，其余是正式渠道
    * @link 产品文档:https://chongdong.feishu.cn/docx/QScYdRcnsottq1xvdoHcOs82n7e
  */
  yuanShanRongCode: {
    value: 'formprocess4',
    code: ['TeW0bz', 'kVTJFC', 'DL6EdU', 'DCxfMs', 'ZrmTkc', 'h426Tz', 'HGQRma', '8BwwgX', '7N5duw', '5vwsSh']
  },

  /**
    * 特殊渠道定制
    * @Infomation 元闪融 - 特殊渠道定制
    * @intruduce uNIXTy是测试渠道，其余是正式渠道
    * @link 产品文档:https://chongdong.feishu.cn/docx/QScYdRcnsottq1xvdoHcOs82n7e
  */
  guideModalCode: {
    value: 'formprocess4-guideModal-productApplication',
    code: ['5ds0MQ']
  },

  /**
    * 特殊渠道定制
    * @Infomation 玄小数 - 特殊渠道定制
    * @link UI 文档:https://www.figma.com/design/32uowLM7szdeKDzCgKn0Ds/%E6%9C%89%E9%92%B1%E6%9D%A5-v2.0?node-id=2711-62297&p=f&t=waJp8vrzc2UUCtuf-0
  */
  XuanXiaoShu2Code: {
    value: 'skin22',
    code: ['T1N7MK']
  },

  /**
    * 特殊渠道定制
    * @Infomation 玄小数 - 特殊渠道定制
    * @link UI 文档:https://www.figma.com/design/32uowLM7szdeKDzCgKn0Ds/%E6%9C%89%E9%92%B1%E6%9D%A5-v2.0?node-id=2711-62297&p=f&t=waJp8vrzc2UUCtuf-0
  */
  XuanXiaoShu3Code: {
    value: 'skin23',
    code: [ 'wlUqo8', 'iCuP1K']
  },

  /**
    * 特殊渠道定制
    * @Infomation 闪信借钱（H5）LD - 特殊渠道定制
  */
  ShanXinJieQianCode: {
    value: 'shallowBlue',
    code: ['6VFo4z', 'hxIGnN', 'xKi4tQ', 'UB1DYF', 'E0vdrC']
  },

  /**
    * 特殊渠道定制
    * @Infomation 闪信借钱（H5）LD - 特殊渠道定制
  */
  ShanXinJieQianABTestCode: {
    value: 'shallowBlue-productApplication',
    code: ['BXq2JR']
  },

  /**
    * 特殊渠道定制
    * @Infomation 闪信借钱（H5）LD - 特殊渠道定制
  */
  fanyangABTestCode: {
    value: 'productApplication',
    code: ['R1fu1y','7JsKuC']
  },

  /**
    * 特殊渠道定制
    * @Infomation 万达定制落地页
    * @intruduce 测试渠道码：XItz0O
  */
  wandaCode: {
    value: 'skin24',
    code: ['IJjimj','XItz0O']
  },

  /**
    * 特殊渠道定制
    * @Infomation 万达定制落地页
    * @intruduce 测试渠道码：XItz0O
  */
  goQingSongCode: {
    value: 'skin25-showUnionProtocol-zhonganXy-gouQingSong',
    code: ['GdBSD2']
  },

  /**
    * 特殊渠道定制
    * @Infomation crm投放定制落地页
    * @intruduce 测试渠道码：ZNHb8x
  */
  crmDisseminateCode: {
    value: 'crmDisseminate-shallowBlue',
    code: ['ZNHb8x','EAKqf9']
  },

  /**
    * 特殊渠道定制
    * @Infomation 新落地页
    * @intruduce 测试渠道码：ZNHb8x
  */
  newSkinABTestCode: {
    value: 'skin26',
    code: ['YN0Hs8','VhJTxE']
  },

  /**
    * 特殊渠道定制
    * @Infomation 有钱钱包定制 26 落地页
    * @intruduce 83J62J 走默认注册流程，仅定制 26 落地页展示
  */

  yqqbSkin26DefaultFlowCode: {
    value: 'skin26-skin26Customized-financeBlueTheme-removeInsurance',
    code: ['83J62J','IsAECI','PO44cS','XjyzOh','2guLIE','4ZJRGr','g0kvJh','pOAIxR','Ti5CWl','WaUPzD','XZ7tGW']
  },

  /**
    * 特殊渠道定制
    * @Infomation 有钱钱包定制 26 落地页
    * @intruduce ho4Y3C 走表单流程 4，复用蓝色资源并将主题色固定为 #0060f3
  */
  yqqbSkin26Formprocess4Code: {
    value: 'skin26-skin26Customized-formprocess4-financeBlueTheme',
    code: [
      'ho4Y3C', 'wCe5xX', 'U4Advf', 'GTfN0E', 'H0TNgB',
      '14nolv', 'MHIbA0', 'mYQPpd', '0p2YiR', '8XcAJA',
      'T7zfly', 'pXSi8i', 'WJvBgk', 'ycwj8I', 'IIZnUh',
      'dElGiG', 'SrBaUA', 'CZx07V', 'HIi60B', 'jbcjr7',
      'iI6e7Q', 'GoFvdL', 'ltlp5x', 'JrKXNP', 'KhASpw',
      'kiXZSA', '0Zj1jj', 'F30QOQ', 'vKUnUb', 'fVugMP',
      'T88lUL', 'oMIRvE', 'eccoR9', '5h9TFi', 'lRaCj1',
      'IU5hxA', 'brNLSc', 'pzKNYv', 'HwgLeK', 'FkHLMr',
      'loMnWn', 'OTq2ow', 'Sj0udF', 'kalkE0', 'wHgz0h',
      'Dm3GBY', '9XsHoC', 'c6k3PL', '69N0G9', '1jgbPw',
      'cZ4gpV', 'xK7djB', 'q94leO', 'TNsMjS', 'yeuMwW',
      'r6ON0Z', 'AzCBSQ', 'ywt0mE', 'NWLsu3', 'MFFC7y',
      '7A3AbM', 'MBWwT5', 'qzk5xF', 'kDhXN8', 'uYDqai',
      'NprC1q', 'ssp53z', 'CvKjpq', 'K8DD9D', '9Q4VmT',
      '8uIWFC', 'YyjGYq', 'crKQ0Y', '5pkibr', '8psiAW',
      '9PA3m2', 'rTwwR0', 'PsWiqE', '20OwCI', 'ExqzGB',
      'f7IUcH', '5bpSY5', 'M76ebH', '8x4RC2', 'kwm5uw',
      'ePiO7P', 'y6T78z', 'Y4fg4U', '8lwPVc', 'd6TFB6',
      'boq4Zn', 'csJdAX', '8q973n', 'zy1PSi', '3J4UvI',
      '4jvSu4', 'XZeu4l'
    ]
  },

  /**
    * 特殊渠道定制
    * @Infomation 新的定制结果页
    * @intruduce 测试渠道码：ZNHb8x
  */
  newSuccessPageCode: {
    value: 'successInstallPage',
    code: ['G1yBmc', 'twMq6m', 'aa7uuM', 'eTa3bN', 'VytTKw', 'wvzLgQ']
  },

  /**
    * 橙易通渠道定制
    * @value chengyitongTheme
  */
  chengYiTongCode: {
    value: 'chengyitongTheme-formprocess4',
    code: ['7vyc6f', 'n4uB4Y']
  },

  /**
   * 特殊渠道定制
   */
  removeCornerMark: {
    value: 'removeCornerMark',
    code: ['DwyjZc']
  },

  /**
   * 特殊渠道定制
   */
  daidaijiaRed: {
    value: 'daidaijiaRed',
    code: [
      'zyluPJ', '0CIxbS', 'bMSicB', 'F6LS8Z', '9HkCbx',
      '4hCOO7', '618RJc', 'z1Syln', 'kfogst', 'tQDidE',
      'siJAIQ', 'anDEpv', 'rExiK1', 'EeQp8o', 'eA2aRD',
      'tJQ1Wb', 'NPeRPG', 'kjAU2q', 'JklEUM', 'z7vJS9',
      'apmJn5', '5yPRjA', 'eb6ry4', '81fcXb', 'gMHsGN',
      'ByErcR', 'IehNs6', '3dsNFW', '2k7IIQ', 'MkTWsT',
      '5BuH6S', 'IKhAYj', 'EbrG8e', 'h7pC2o', 'nPlNnZ',
      'R7nYMk', 'LIXUy8', 'IcPfFJ', 'Xkoxdd', 'vO39Kv',
      '3QmcET', 'IVO7g2', 'lGJWDw', 'CQslnB', 'WstJe9',
      'Lnnsg7', 'F3kTMF', 'Ssepjb', 'uaQkxQ', 'uPNXDY',
      '8IrkL9', 'gARhXP', '4fcmk8', 'SNnerc', 'A42Zvo',
      '5CZa9S', 'r8mLdQ', '2l8MDf', 'i6GC2C', 'PGBkPE',
      '5nFIgA', 'bzaBgJ', 'kNr19i', 'qlJtAP', 'J3hsDI',
      'IZedRa', 'oq4ztX', 'Ala8YG', 't1v3Nh', 'MucVRT',
      'E2zNdO', 'BsJRs3', 'sP0YQQ', '4BdVIL', '1nmivZ',
      '2Iubvb', 'TM7cuW', 'pf2oat', 'zF9zS7', 'r7KC5k',
      'D9VvAn', 'n6yzRm', 'vP2EgK', 'kFbbjg', '0xzVK0',
      'wQUhO3', 'ATOqTF', 'XVdkfq', 'ixbk2y', 'kTHw0X',
      'LErZ9h', 'Olw3gS', 'Akn2vJ', 'ivbBsY', 'uI5VZ1',
      '82kpo4', 'BCUfup', 'WdmFPh', 'tGcXbg', 'x5rvxd',
      'e5t2IC', 'NNsyRf', 'ZcW5Zm', 'zXg6VP', 'YTO5mp',
      '07mTik', 'dJJrCI', 'raVdNZ', 'F9LBYf', 'mvwn5z',
      'mJiouW', 'JiQ9E8', '0zKeb5', '3zs5Vg', 'AFpRyn',
      '4jhknF', 'bzMvhf', 'cEU51d', 'h9SFTZ', 'ILG5kB',
      'nBW6UW', 'WePGcO', 'GuT7Vb', 'ZvKJBq', 'ZcACyh',
      'VsmCKz', 'n94uQS', 'WAJ910', 'WNJzx6', 'neD5XG',
      'F133LC', 'RsvTde', 'onrm4C', 'E9adw8', 'bH8wbO',
      'CUtLW0', 'Th2naW', 'Gzbw28', 'KLxBC0', 'ZTeEOg',
      'pijYJN', 'AAd0TM', 'JL388w', 'Z5bHC1', 'mAwBcA',
      'dNS3oc', 'w7Xp9i', 'fOKQWT', 'g6pPzB', 'd3kSFo',
      'KL0Gz2', 'k4ONq8', 'OqUqoA', 'QDpLAF', 'ELjqRE',
      'bed96h', 'DjPaMn', 'FXP18P', '1tyFeK', 'dCO0Kd',
      '7PIoWs', 'a7bYEt', 'tRbMPE', 'nBagJW', 'ZClwyD',
      'o4oTxC', 'DJ3ZDe', 'MHY2sY', '1ln7k7', 'KeXTYc',
      '2FjHVW', 'ODvQ6X', 'WvMU5n', 'Uy64G5', 'hyWQ5M',
      'HgqlpI', 'FXYiw1', '7rGO63', '5q0hQy', 'R7cmsA',
      'i7dtmH', 'KQGCUj', 'Lqg9Qq', 'dryjhZ', 'YX7Fy1',
      'hcEblk', 's6y19O', '00juGH', 'cKfNrO', 'BU2uzi',
      'E4cU2P', 'kqe1b5', '1Z1rnk', 'bDlZRR', 'YkCKGH',
      'sEfxf4', 'WTgPCU', 'lc83ij', 'uqbv70', 'zyBGUl',
      'VwtPWn', 'dxA3g5', 'rg2UgQ', 'sefWr5', 'ZzdvwT',
      'pbjXxK', '3cjoux', 'cLU1aR', '5G991u', 'MEB7G9',
      'JHBrMq', 'sRZmI4', 'vFypUP', 'FYb8kw', 'opQMf4',
      'cI9OtU', 'yWQxpP', 'bPzVmi', '0ZBTFm', 'NL9Otm',
      'FsdCiB', 'ty0wJy', 'j26JLf', 'pgdTO0', 'ahPeMO',
      'abWzTw', 'JMavpj', 'TcTd7g', '6LsMew', 'crGfX6',
      'M27IDG', '9YUuJO', 'Kom8h4', 'cjaPRn', 'CooOkl',
      'U9VJdi', '0kSudY', 'Ye7cHK', 'fT2FY6', 'O8bDve',
      'zSCYtg', 'YaXmJi', 'G0JNh8', 'KkC49M', 'H10m7L',
      'zJEQ52', 'OFnIAe', 'x6D4T7', 'HEYzbe', '0SAqbk',
      'aRTpY9', 'lAdBeL', 'doOdkt', '6Jwk8C', 'aWuZHa',
      '7IpcQN', 'H95HkB', 'F50zKx', 'OWNXbG', 'qPqeVX',
      'vxUOHu', 'CYySwb', 'NxJDRr', '16D67Q', 'MxgIwO',
      'H1FZFC', 'SjhxGb', '3PJPFC', '8X7MVt', 'NJtG3M',
      'XVllem', 's2hD13', 'M00cV7', '9xbpeg', 'EZDkQ9',
      'CFuCi0', '3bh5mJ', 'HyiW2a', 'UxN8E9', 'Bc8PGW',
      'Rz9ggT', 'ekhKNT', '2XJdGA', 'STl7P6', '0CbPPZ',
      '8IvnSD', '3GW1lP', 'tagl1F', 'VQCm9J', 'F4qLwn',
      'o9dS8S', 'kJEs5a', 'sKEOMd', '1L7ilR', 'I6JHYf',
      'JOHb8M', '5Zl75k', 'HEA0UZ', 'm0LwTs', 'FhyYEM',
      '8FsoCU', 'sGXPwR', 'TEZWJK', 'bajLYp', 'bMG2hb',
      'SBotQL', 'FUJ9CL', 'gTp9m8', 'tkVeR4', 'n4xInf',
      'o6aSER', 'RjVleB', 'I9OIaq', 'QsBWq0', 'R5KnM9',
      '9ivXeG', 'W52j6i', 'nHp7yp', '0HlQK4', 'sa0yTS',
      'ordM6q', 'houoKG', 'q6dc8O', 'nN9StK', 'cY1ABA',
      'X5O5oU', 'JuXFuk', 'C7Dheg', 'EEWXuQ', '3t18Pf',
      'rkXdGR', 'kpuasR', 'Myo7Qf', '5srxFP', 'zgLheI',
      'MQkYan', 'ZCulBO', 'i2lnhH', 'SDEbpE', '3EtCIO',
      'BUJsMy', 'xuWIP7', '4XJgZ6', 'Aw9Uie', 'ZS9XK4',
      '1QctSZ', 'XHKKdP', 'MqAH0h', 'dpgUGQ', 'MfCWZs',
      'ZFIOuT', 'vDzddw', 'VkJmi5', 'L4kc7F', 'eGbZSN',
      '5ZsTME', 'W8k6Vw', '7UXQKB', 'A9ymBK', 'vJAB45',
      '19OC4P', 'ioH76G', 'iGjDqe', 'qhh4X3', 'CtLc9v',
      '78XcvI', 'SIN8ZY', 'ITULwx', 'qnQely', '5KLlYY',
      '7n9lwo', 'YUXzBu', 'mnBMte', 'fTDjWl', 'jW4JKs',
      'LbQxOJ', '7022Gr', 'FSHfn4', 'bEKOLf', 'Gi8YA8',
      'ytbpbT', 'UHwCzG', 'ztS7fv', 'ANwMp1', 'sKz7RB',
      'bXAKaD', 'syrKyw', 'gNE6YW', 'DMebXo', 'nsDiWN',
      '4lOrDU', 'v2knOd', '3BZmD0', 'bO1etW', 'nISXB8',
      'n6GZrf', 'EJHIm1', 'KLssPN', 'VANsPN', 'IhsZ4u',
      '5Zd4Fz', 'wrD1k8', '2DGOeM', 'Y509Oz', 'CPDhUl',
      'T57Rv7', 'IGrnnK', 'MOqr01', 'pOgFNu', 'jBYBxa',
      '4BAcQ0', 'JNFJj0', 'tHs87V', 'eemqGM', 'FflFEm',
      '61ClAS', 'ozNsTq', 'HfWOlh', 'EYcvh2', 'm5dFnf',
      'V7qHqp', 'BHHcP8', '4ofGpy', '12uoJN', 'pZyA6u',
      '4k0b79', 'zsTDhZ', 'Br8ik0', 'hKEfPQ', 'r95xVR',
      'FGUOI6', 'qwIxpW', 'snFIhg', 'N5r64e', 'lm9QWM',
      'rrcqqD', '0CNBba', 'mEljk1', '0if6hB', 'hYpzgB',
      'C7cvEs', 'z3sNO3', '1cbBEO', 'jHtKEx', '6N4jmH',
      'heDmZe', 'VbrhQd'
    ]
  },

  /**
   * 1.3.5 城市选择器渠道灰度
   * @intruduce itZjc3 是测试渠道码
   */
  channelCityPickerCode: {
    value: 'channelCityPicker',
    code: ['itZjc3', 'IvJuCe']
  },

  /**
   * 神付通定制 + 表单流程 5
   */
  shenfutongFormProcess5Code: {
    value: 'shenfutong-formprocess5',
    code: ['Aj7D7t']
  },

  /**
   * 神付通
   */
  shenfutongCode: {
    value: 'shenfutong',
    code: [
      '8TaJFa', 'Scub41', 'Kl6YKQ', 'DXnU1U', 'tz3Igl',
      'ML171c', 'EB8ttb', '2Hkspk', 'N86Ugp', 'HUVatJ',
      'zaZQp6', 'EPQXgA', 'pPhzhV', 'j4yOge', '5ihvoy',
      'gj3JdN', 'TrIzse', '1rID9g', 'FfZL0q', 'P7ObjB',
      'RNu6Wo', 'Hii14p', 'AfXkY6', 'YvyRDe', '3xLJWc',
      '8SrH1G', 'BDyVNa', 'Nz4ntB', 'tRkKsi', 'XC4Tl5',
      'XgoSbd', 'SeohIp', 's7EP6d', 'Pq21JI', 'dy3jLT',
      '9J4JkN', 'Dfn6aT', 'XQl4z3', 'w6jIna', 'sw0pox',
      'n1M5OZ', 'H3oKzE', 'c36iKd', 'RXLbvA', 'IS95ct',
      'KeVnwr', 'ttAdO0', 'sXTBgt', 'jY1Uzo', 'Wzwrnl',
      'Lc3I3q', 'OtYvbu', 'IloOwr', 'FCiPEf', 'UBQ9n7',
      'jszYTI', '8bPMwf', '18LRfO', 'w7TONW', '5K31Vv',
      'p7mh8X', '5oVLu5', '3YposB', 'yyA1zs', 'MUYVQB',
      'N0qle4', 'ovD0jv', 'nJ2usf', 'CYaCZu', '6nnxxW',
      '6v61k0', 'wivjf3', 'UtBE4G', 'YiuOUo', 'Aoif3V',
      'Oe3Jpg', 'uSKJ1S', 'SFJe79', 'BqhKSm', '8y08hU',
      'jKfWy7', '75SwWX', '8yjWNp', '1d4PKx', 'vRBcOk',
      'NR6vZ1', 'ZCTnEO', 'AgsaNU', 'pbsIaM', 'qaHzNG',
      'YXr6uR', 'js48jX', '7IPrjW', 'Re2t1g', 'z7CFJf',
      'YCuLlB', 'lyE98o', 'cNsPdN', 'Noql72', 'GayA9m',
      '7esSUW', 'jcEbO2', 'mHhzho', 'fosVd1', 'vgsOwe',
      'Va7RxP', 'pehDv5', 'YmzAsy', 'H3O4x0', 'HViqGE',
      'oaur12', 'tCz1cc', 'sDgJyN', 'pJhjyZ', '4V9xv8',
      'DissqA', 'uqoKjA', 'O36MCe', 'r9iLFi', 'V6eOyI',
      'w8p0aN', '2N5SQe', 'LgI1D8', 'bSzxFh', 'QUSBgH',
      'Q1rdtM', '3RDtHR', 'SIjWm8', 'YZoIU0', '4j3IAG',
      'S1igE0', 'VTpsA1', 'C9Z5cU', '3QzcZN', 'HW2dIR',
      'nfBWBM', 'KN21R4', 'oPWHLz', 'd1Mdo1', 'gBfbpx',
      'O1O3ge', '92pa2O', 'ACUrdb', 'DJggaL', 'IItvBf',
      'bkdB3M', 'eooUnJ', '9jFIxJ', '4g3oYF', 'YS52H4',
      'd69Z0o', 'zKSpts', 'QnSJRn', 'wvYtsf', 'nSNjWo',
      'kk6KGP', 'AqRc13', 'YtC23L', 'jMPmnz', '2HT5IP',
      '4E1ufk', '3E0aOB', '2e1M9M', 'dpx7xs', 'Y1WPOo',
      'VKY5IB', 'dKLr8p', '9q5rdX', 'vmN0MY', 'ZZi9o7',
      'VRP6yC', 'Q3Jcsv', 'N70SIj', 'aBg5tE', '8bhGK0',
      'WKp9Mw', '3nl4Ov', 'pc96Bj', 'OcN14S', 'FcaeeT',
      'PuAfLs', 'Mj172i', '8bWwiu', '1sWpaK', 'fDepjf',
      '4grW8v', 'KHecFa', 'UuZoxF', '4AWHZh', 'wQCNmP',
      'O3z3uO', 'dVPHnt', 'IJsA2g', 'FQW7UB', 'oOPYtn',
      'zJyNW3', 'R2OG3e', 'HtrqDd', 'v7Qwkc', 'QIykyt',
      'p1QNEa', 'zzm5aj', 'lRaqST', '6QLPZy', '5OmNma',
      'zJc8Vi'
    ]
  },

  /**
   * 贷小悠
   */
  daixiaoyou: {
    value: 'daixiaoyou',
    code: [
      'FsYGih', '9DT4Ht', 'RIUIID', '499KdT', '8RIYTp',
      '9LusP6', 'FdP6lW', 'K8AFav', 'Xsmmqw', '7eOWT3',
      'EzFCpA', 'fiS7m5', 'pdsWU0', 'mfFmsT', 'HebNvm',
      'VbEacz', 'vFwY9d', '9aGibL', '8qjimI', '0IIKtw',
      'czwWB9', 'ZXeAru', '6ban8o', 'eUeSPR', 'TSK4n9',
      'Xy1VoU', '6rPzLr', 'R9VLyB', 'KQYUv9', 'v564lm',
      'SU6T99', 'dchX6g', 'Cc51Nq', 'p9JSoO', 'uaNj4l',
      'MgPElS', '2w3ASG', 'awk9D9', 'X0L79m', 'vovafe',
      'OaDuST', 'lFZYsJ', 'cdKJac', 'DmOxv2', 'jOD2lo',
      'Ynkipg', 'ivg5PB', '99w4Rx', 'hHgypH', 'jR8Q36',
      'eklxGC', 'VITGxs', 't7krWH', 'awJrnE', 'G0zpkz',
      'yWe6qb', '3oMwC9', 'eot4of', '40wpst', 'xus7d6',
      'dFPMSi', 'hGFC4z', 'drXx9u', '7CRs3K', 'h6qQmb',
      'vH1blk', 'FFeugW', 'M9BeZQ', 'UUWpNJ', '9pSusk',
      'LjW2EB', 'cTGdsW', 'avbhEt', '8dxgMK', 'bubXdk',
      'Q8G2Sn', 'kcM71a', 'KwhSAI', 'd0onpI', '7cvHSS',
      '9gRbIy', 'IwsVhZ', 'OPytU3', 'dchjtX', 'LWX3pJ',
      '7HDlKB', 'bKxhmT', 'wKhzz1', 'bEaLiN', 'A7WGRD',
      'xmbXb8', 'iVNs83', 'OpKq3W', 'RYH01g', 'U0ydrc',
      '8V9V4j', 'ZaLkeI', '9iJWgS', '2pd9Sm', 'hWEBaW',
      'WfXpc6', 'vLfYFQ', '7BhfuJ', 'CvLjtV', 'bKzgIF',
      'rgsmPk', 'o6jAn8', 'ekB1mh', 'euPmDy', 'e4VzNV',
      'FRtT7i', 'cSAMXx', 'XQdWi2', 'it5QFf', 'olZvOF',
      'jgL4o6', 'VY3lJI', '5FNGeE', 'njE44Y', 'rtNFuA',
      'cno2Um', '6g3DSn', '7yjnSo', 'BxE94n', 'lGlzzS',
      'RF9YjE', 'xj4yzd', '43zQVt', 'Pw9C3q', '47IQq6',
      'DWntyj', '1lW4sD', 'PftrnK', '5fY0HA', 'z47FAS',
    ]
  },

  /**
   * 特殊渠道定制
   * @Infomation v1.6.7 部分渠道 H5 落地页调整
   * @intruduce qNmnBA 测试渠道码
  */
  skin28Code: {
    value: 'skin28',
    code: ['qNmnBA', '9nfHCX', 'rXZHFV', 'qLKSuF', 'Sjz9O1']
  },

  /**
   * 测试微信环境注册页使用点击注册的按钮是否有影响
   * @intruduce itZjc3 是测试渠道码
   */
  btnTextRegisterNowCode: {
    value: 'btnTextRegisterNow',
    code: ['atrLny']
  },

  daixiaoyouTF: {
    value: 'daixiaoyouTF-skin28',
    code: [
      'CNB4w3', 'ygA9tr', '3F1Igc', 'eEq5Dr', 'JY8ked',
      'Xup7fp', 'Luwl1J', 'yi1Fet', 'AAzOyL', 'fGpYtG',
      'abpYpY', 'ySBiUA', 'VJBrWu', 'baUMXT', 'Hydtfa',
      'q8af1z', 'QCHLfJ', 'U9s6FN', 'nG6m4r', 'SurNGP',
      'oRRRQs', '5JXn7x', 'qhVwAU', 'Xd8awL', 'ESffim',
      '6ajFNg', 'AqZ63g', 'WTZF6G', '88gUgW', 'QWtofN',
      '8khyQZ', '7PGgzm', 'm9Gb5u', 'MlvKn8', 'O51bQa',
      '0W5Xrn', 'Xv69CN', '2yYSZR', 'wglcfc', 'MWwLA5',
      '1EYhwq', 'ilfY3K', 'T1zDlK', 'PkRtPF', 'gpAQE5',
      'OTA21p', 'H4ZTnf', 'BIGS2q', 'fBe2YN', 'xYfbTE',
      'f0RnXt', 'e5KDWX', 'uDdZGD', '7h7r8F', 'rBDzih',
      'KTV9ou', '6Er0Ff', 'F1vkp4', '6MTtLt', 'P48xvt',
      '4Oq5dt', 'FqtDpb', 'q0bkSl', 'oNDE9w', '2uMmz0',
      'dLku7v', 'DOPaOj', 'c9O56x', 'Q3X81m', 'M2NYIb',
      'MMJouT'
    ]
  },

  /**
   * 特殊渠道定制
   * @Infomation 及锋非标渠道 skin27 落地页协议默认不勾选
   */
  skin27jifengfeibiao: {
    value: 'jifengfeibiao',
    code: ['kKBTGB', 'IpDTTt']
  },

  /**
   * 测试非标渠道
   * */
  /*testFeibiao: {
    value: 'test-formprocess5',
    code: ['OTSaTm']
  }*/
}

const getSpecialCode = (code: string, specialCodeMap: Record<string, { value: string; code: string[] }>): string | null => {
  for (const [, value] of Object.entries(specialCodeMap)) {
    if (value.code.includes(code)) {
      return value.value
    }
  }
  return null
}

interface AdChannelStore extends adChannelState {
  setAdChannelCode: (code: string) => void
  setRouteCodeDetail: (adRouteCode: string, detail: getAdChannelCodeByRouteCodeRes) => void
  clearRouteCodeDetail: () => void
  restoreRouteCodeDetail: (context: RouteCodeDirectDrainageContext) => void
  checkSpecialChannel: () => void
  getCodeDetails: (code?:string) => Promise<ChannelDetailResponse>

}

export const useAdChannelStore = create<AdChannelStore>((set, get) => ({
  adChannelCode: '',
  isSpecialChannel: false,
  specialCode: specialChannelCode,
  channelValue: [],
  codeDetailCache: null as ChannelDetailResponse | null, // 缓存字段
  noStandardChannel:false,
  adRouteCode: '',
  routeCodeDetail: null,

  setAdChannelCode: code => set({ adChannelCode: code }),
  setRouteCodeDetail: (adRouteCode, detail) => {
    // 路由码会被兑换成渠道码并从 URL 移除；外跳下游再返回时需要用 sessionStorage 恢复导流上下文。
    sessionStorage.setItem(ROUTE_CODE_DIRECT_DRAINAGE_CONTEXT, JSON.stringify({
      adRouteCode,
      routeCodeDetail: detail
    }))
    set({ adRouteCode, routeCodeDetail: detail })
  },
  clearRouteCodeDetail: () => {
    // 导流链路结束或当前渠道码和路由码兑换结果不一致时，必须同时清掉会话缓存和运行时状态。
    sessionStorage.removeItem(ROUTE_CODE_DIRECT_DRAINAGE_CONTEXT)
    set({ adRouteCode: '', routeCodeDetail: null })
  },
  restoreRouteCodeDetail: context => {
    set({
      adRouteCode: context.adRouteCode,
      routeCodeDetail: context.routeCodeDetail
    })
  },

  checkSpecialChannel: () => {
    const { adChannelCode, specialCode } = get()
    let specialValue = getSpecialCode(adChannelCode, specialCode)?.split('-') || []
    set({
      isSpecialChannel: !!specialValue,
      channelValue: specialValue
    })
  },
  getCodeDetails: async(code?: string) => {
    const { adChannelCode, codeDetailCache } = get()
    const finalCode = code ?? adChannelCode

    if (!finalCode) {
      return {} as ChannelDetailResponse
    }

    // 如果缓存存在且 code 匹配，直接返回
    if (codeDetailCache?.adChannelCode === finalCode) {
      return codeDetailCache
    }

    // 否则发起请求并更新缓存
    const codeDetails = await retry(() =>
      activityApiDecorator.getChannelCodeDetailCache(finalCode, { isCancelRequest: false })
    )

    // 判断是否非标渠道
    let channelTypeId = isProduct ? 6 : 8
    if (codeDetails.primaryChannelId === channelTypeId) {
      set({ noStandardChannel: true })
    }

    set({ codeDetailCache: codeDetails })
    return codeDetails
  },
}))
